import { TEXT_DELIMITED_MULTISELECT_FILTER_LIMIT } from '~/common/constants/max_lengths';
import { Field } from '~/evifields/src/types/Field';
import { Filter } from '~/evifields/src/types/Filter';
import { OperatorId } from '~/evifields/src/types/OperatorId';
import { AsyncValue, Value } from '~/evifields/src/types/Value';
import { DOCUMENT_ID_FILTER } from '~/features/filters/constants';
import { Nullable } from '~/types/Nullable';

export const clearFilter = (filter: Filter) => ({
  ...filter,
  asyncValue: undefined,
  operatorId: null,
  hasError: false,
  values: [],
});

export const clearFilterValues = (filter: Filter): Filter => ({
  ...filter,
  asyncValue: undefined,
  hasError: false,
  values: [],
});

export const updateFilterOperator = (
  filter: Filter,
  operatorId: Nullable<OperatorId>,
) => ({
  ...clearFilter(filter),
  operatorId,
});

export const updateFilterValues = (
  filter: Filter,
  values: Value[],
  asyncValue?: AsyncValue<Value>,
) => {
  return {
    ...filter,
    asyncValue,
    hasError: false,
    values,
  };
};

export const isValidFilterValue = (filter: Filter, field: Field): boolean => {
  // TextDelimitedEnumSetValue is special filter type, cannot contain more than 10,000 values
  // Can be used as a special case with Document ID TextValue filter
  // or, when field type is enum_set
  if (field.label === DOCUMENT_ID_FILTER && filter.values?.[0]) {
    const value = filter.values[0] as string;
    return value.split(',').length <= TEXT_DELIMITED_MULTISELECT_FILTER_LIMIT;
  }
  if (field.type === 'enum_set' && filter.filterView === 'text-delimited') {
    return filter.values.length <= TEXT_DELIMITED_MULTISELECT_FILTER_LIMIT;
  }

  return true;
};
